import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FileInput, Checkbox } from "@blueprintjs/core";
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useHistory } from "react-router-dom";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";
import "./DividendProcess.scss"

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import { WithdrawalInfo, StkCodeInfo, AcCodeInfo } from './Types'
import { SystemHeader } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;



interface ATI_Adj1MainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function ATI_Adj1Main({ gsb }: ATI_Adj1MainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    const history = useHistory()

    const [Data, setData] = useState([] as WithdrawalInfo[])

    const [searchKey, setSearchKey] = useState("StkNo")

    const [showFilters, setShowFilters] = useState(false)
    const [searchStkNo, setsearchStkNo] = useState("")
    const [showButton, setshowButton] = useState(true)
    const [ShowWait, setShowWait] = useState(false)

    const [RptName, setRptName] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [BlankWithdrawal, setBlankWithdrawal] = useState({} as WithdrawalInfo)
    const [currentWithdrawal, setcurrentWithdrawal] = useState({} as WithdrawalInfo)

    const [s_StkNo1, sets_StkNo1] = useState("")
    const [s_StkNo2, sets_StkNo2] = useState("")
    const [s_SplitConsolidate_Old, sets_SplitConsolidate_Old] = useState("")
    const [s_SplitConsolidate_New, sets_SplitConsolidate_New] = useState("")

    const [SplitConsolidateData, setSplitConsolidateData] = useState([] as WithdrawalInfo[])
    const [SplitConsolidateItemNo, setSplitConsolidateItemNo] = useState(10)

    const [file1Label, setFile1Label] = useState("Choose file...")
    const [nUploaded, setnUploaded] = useState(0)
    

    const [currentMode, setcurrentMode] = useState("show")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")
    const [dateFormat, setdateFormat] = useState("")
    const [HKIDR_USER, setHKIDR_USER] = useState(false)


    BlankWithdrawal.d_acCode = ""
    BlankWithdrawal.d_StkNo1 = ""
    BlankWithdrawal.d_StkNo2 = ""
    BlankWithdrawal.d_SplitConsolidate_Old = "0"
    BlankWithdrawal.d_SplitConsolidate_New = "0"

    

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("ATI_Adj1Main disp user_key: ", res.data.Flag.user_key)
                //console.log("ATI_Adj1Main disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("ATI_Adj1Main disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("ATI_Adj1Main disp GsbFlag: ", GsbFlag)
                //console.log("ATI_Adj1Main disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("ATI_Adj1Main disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("ATI_Adj1Main disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("ATI_Adj1Main disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("ATI_Adj1Main disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setdateFormat(GsbFlag.dateFormat);
                setHKIDR_USER(GsbFlag.HKIDR_USER) ;

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])


    useEffect(() => {
        setshowButton(true)
    }, [s_StkNo1, s_StkNo2, s_SplitConsolidate_Old, s_SplitConsolidate_New])


    useEffect(() => {
        console.log("append SplitConsolidateData SplitConsolidateItemNo: ", SplitConsolidateItemNo) 
        for (let i = SplitConsolidateData.length+1; i <= SplitConsolidateItemNo; i++) {
            SplitConsolidateData.push(BlankWithdrawal)
        }
    }, [SplitConsolidateItemNo])



    const onChangeStkNo = (i: number, StockNo: string) => {
        if (i >= 0) {
            console.log("onChangeStkNo : ", i, StockNo) 
            let newData = [...SplitConsolidateData]
            newData[i] = {
                ...newData[i],
                d_StkNo1: StockNo
            };

            setSplitConsolidateData(newData);
            setshowButton(true)
        }
    }

    const onChangeOldQty = (i: number, Qty: string) => {
        if (i >= 0) {
            console.log("onChangeOldQty : ", i, Qty) 
            let newData = [...SplitConsolidateData]
            newData[i] = {
                ...newData[i],
                d_SplitConsolidate_Old: Qty
            };

            setSplitConsolidateData(newData);
            setshowButton(true)
        }
    }

    const onChangeNewQty = (i: number, Qty: string) => {
        if (i >= 0) {
            console.log("onChangeNewQty : ", i, Qty) 
            let newData = [...SplitConsolidateData]
            newData[i] = {
                ...newData[i],
                d_SplitConsolidate_New: Qty
            };

            setSplitConsolidateData(newData);
            setshowButton(true)
        }
    }


    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        setnUploaded(0);

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        if ( HKIDR_USER ) {
            if ( file1Label == "Choose file..."  || file1Label.length == 0) {
                utils.showError("Please choose a file"); 

                return
            } 

            (async () => {
                try {
                    const res = await gsb.post('/importupload2',
                        new FormData(e.target as HTMLFormElement), {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });

        
                    setnUploaded(res.data.uploaded)
                
                    utils.showSuccess(`${res.data.uploaded} file(s) uploaded`)

                    onATIAdjProcess()
                    
                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            onATIAdjProcess()
        }

    }        



    const onATIAdjProcess = () => {


        setShowWait(true)
        setshowButton(false)
        setRptName("")
        ;

        console.log("onATIAdjProcess Data", SplitConsolidateData);
        (async () => {
            try {
                const res = await gsb.post('/Transaction', {
                    sb_data: {
                        SplitConsolidateData: SplitConsolidateData,
                        s_StkNo1: s_StkNo1,
                        s_SplitConsolidate_Old: s_SplitConsolidate_Old,
                        s_SplitConsolidate_New: s_SplitConsolidate_New,
                        impfileName: file1Label
                    }, 
                    cPgmId: "Ati_Rpt",
                    cAction: "ATI_Adj1Process",
                })                
                if ( res.data.ok ) {
                    utils.showSuccess(res.data.data)
                    setData(res.data.data)
                    setRptName(res.data.RptName)
                } else {
                    utils.showWarn(res.data.data)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
    }

    
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>


    let RptNameaRef = <>
        <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>
        <div className="Spacing-V-16" />
        Please download the ATI file at the above link !!
    </>


    let list = <>
        <div className="Row">
            {/* <Button disabled={! showButton} className="Col-1-1" icon="confirm" onClick={() => { onATIAdjProcess() } }>Process</Button>  */}
            <Button disabled={! showButton} className="Col-1-1" type="submit" icon="confirm" >Process</Button> 
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        <HTMLTable striped interactive condensed>
            <tbody id="ma_tr">
                {Data.map((RstMsg, i) =>
                    <tr key={i} onDoubleClick={() => { } }>
                        <td onClick={() => { } }>{RstMsg}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {RptName.trim().length > 0 && RptNameaRef}
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>


    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <div>
                        <H3>ATI Output File Adjustment - Stock Split/Consolidate </H3>
                    </div>
                    <div className="Spacing-V-16" />
                    {/*
                    <div className="Row">
                        <FormGroup inline className="Col-1-5" label="Stock No. for Adjustment" labelFor="inputStkNo1">
                            <InputGroup
                                id="inputStkNo1"
                                autoFocus={true}
                                placeholder="Stock No ..."
                                value={s_StkNo1}
                                onChange={utils.handleStringChange(s => sets_StkNo1(s))}
                            />
                        </FormGroup>
                        <FormGroup className="Col-6-3">
                            <div id="DispText">{currentWithdrawal.d_StkCode1}</div>
                            <div id="DispText">{currentWithdrawal.d_StkName1}</div>
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup inline className="Col-1-3" label="Split/Consolidate" labelFor="inputSplitConsolidate_Old">
                            <InputGroup className="inputNumberNoSpin" type="number"
                                id="inputSplit_Old"
                                value={s_SplitConsolidate_Old}
                                onChange={utils.handleStringChange(s => sets_SplitConsolidate_Old(s))}
                            />
                        </FormGroup>
                        <FormGroup inline className="Col-4-3" label="into shares" labelFor="inputSplitConsolidate_New">
                            <InputGroup className="inputNumberNoSpin" type="number"
                                id="inputSplit_New"
                                value={s_SplitConsolidate_New}
                                onChange={utils.handleStringChange(s => sets_SplitConsolidate_New(s))}
                            />
                        </FormGroup>
                    </div>
                    <div className="Spacing-V-16" />
                    */}
                    <div className="Spacing-V-16" />
                    <HTMLTable striped interactive condensed>
                    <thead>
                        <tr>
                            <th className="TCol-StockNo">Stock No</th>
                            <th className="TCol-Stock_Code"></th>
                            <th className="TCol-TradeQty">Split/Consolidate</th>
                            <th className="TCol-TradeQty">into shares</th>
                        </tr>
                    </thead>
                    <tbody>
                        {SplitConsolidateData.map((item, i) =>
                            <tr key={i}>
                                <td className="TCol-TradePrice" onClick={() => { }}><InputGroup className="" id="inputStkNo1" defaultValue={item.d_StkNo1} onChange={utils.handleStringChange(s => onChangeStkNo(i, s))} /></td>
                                <td className="TCol-TradePrice" onClick={() => { }}>{item.d_StkCode1} </td>
                                <td className="TCol-TradePrice" onClick={() => { }}><InputGroup className="inputNumberNoSpin" id="inputSplit_Old" defaultValue={item.d_SplitConsolidate_Old} onBlur={utils.handleNumericBlur(s => onChangeOldQty(i, s))}  onChange={utils.handleStringChange2(s => onChangeOldQty(i, s))} /></td>
                                <td className="TCol-TradeQty" onClick={() => { }}><InputGroup className="inputNumberNoSpin" id="inputSplit_New" defaultValue={item.d_SplitConsolidate_New} onBlur={utils.handleThousandsBlur(s => onChangeNewQty(i, s))} onChange={utils.handleThousandsChange(s => onChangeNewQty(i, s))} /></td>                                                
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="TCol-StockNo" onClick={() => { setSplitConsolidateItemNo(SplitConsolidateItemNo+5) } } id="DispText" style={{justifyContent: 'flex-end'}}>+ More 5 items</td>
                        </tr>
                    </tfoot>
                    </HTMLTable>
                    <div className="Spacing-V-16" />
                    { HKIDR_USER &&<div className="Spacing-V-16" /> }
                    { HKIDR_USER &&<div className="Row">
                        <FileInput className="Col-1-3" inputProps={{ name: "file1" }} text={file1Label} onInputChange={utils.handleStringChange((s) => setFile1Label(utils.fileBase(s)))} />
                    </div> }

                    <div className="Spacing-V-16" />
                    <div className="Spacing-V-16" />
                    {list}
                    <div className="Spacing-V-16" />
                    <p>Notes</p>
                    <div>
                        {! HKIDR_USER && <div>Re-write the T date, T+1 date of ATI output file at the out\ATI directory for HK market
                        </div> }
                    </div >
                </Card>
            </form>
        </>
    );
}

export default ATI_Adj1Main